export default "__VITE_ASSET__cuQt6VIu__";